(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solenna-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solenna-hero')) {
    class SolennaHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-sl-slide]'));
        if (this.slides.length < 2) return;

        this.index = 0;
        this.dots = Array.from(this.querySelectorAll('[data-sl-dot]'));
        this.toggleBtn = this.querySelector('[data-sl-toggle]');
        this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;
        this.autoplay = this.dataset.autoplay === 'true' && !reduced && !inEditor;
        this.userPaused = !this.autoplay;
        if (!this.autoplay) this.classList.add('is-paused');
        if (this.toggleBtn && !this.autoplay) this.toggleBtn.setAttribute('aria-label', 'Reproducir carrusel');

        const prev = this.querySelector('[data-sl-prev]');
        const next = this.querySelector('[data-sl-next]');
        if (prev) prev.addEventListener('click', () => { this.goTo(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.goTo(this.index + 1); this.restart(); });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => { this.goTo(parseInt(dot.dataset.slDot, 10)); this.restart(); });
        });
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', () => this.toggle());

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.start(); });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { this.goTo(this.index - 1); }
          if (e.key === 'ArrowRight') { this.goTo(this.index + 1); }
        });

        this.onVisibility = () => { if (document.hidden) this.stop(); else this.start(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        this.setupSwipe();

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.goTo(i); this.stop(); }
        };
        this.onBlockDeselect = () => this.start();
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      setupSwipe() {
        let startX = 0;
        let startY = 0;
        let tracking = false;
        this.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (!tracking) return;
          tracking = false;
          const dx = e.changedTouches[0].clientX - startX;
          const dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
            this.justSwiped = true;
            setTimeout(() => { this.justSwiped = false; }, 400);
            this.goTo(dx < 0 ? this.index + 1 : this.index - 1);
            this.restart();
          }
        }, { passive: true });
        this.addEventListener('click', (e) => {
          if (this.justSwiped) { e.preventDefault(); this.justSwiped = false; }
        });
      }

      goTo(i) {
        const total = this.slides.length;
        const nextIndex = (i + total) % total;
        if (nextIndex === this.index) return;
        this.slides.forEach((slide, n) => {
          const active = n === nextIndex;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.dots.forEach((dot, n) => {
          if (n === nextIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.index = nextIndex;
      }

      start() {
        if (this.userPaused || this.timer) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      toggle() {
        this.userPaused = !this.userPaused;
        this.classList.toggle('is-paused', this.userPaused);
        if (this.toggleBtn) {
          this.toggleBtn.setAttribute('aria-label', this.userPaused ? 'Reproducir carrusel' : 'Pausar carrusel');
        }
        if (this.userPaused) this.stop();
      }
    }
    customElements.define('solenna-hero', SolennaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solenna-popup-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sl-quiz-popup')) {
    class SlQuizPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.key = 'slq-' + this.dataset.sectionId;
        this.inEditor = !!(window.Shopify && window.Shopify.designMode);
        this.opened = false;

        this.querySelectorAll('[data-slq-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
        this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
        this.querySelectorAll('[data-slq-option]').forEach((b) => {
          b.addEventListener('click', () => this.showStep(b.dataset.slqOption));
        });
        this.querySelectorAll('[data-slq-back]').forEach((b) => b.addEventListener('click', () => this.showStep('question')));
        this.querySelectorAll('[data-slq-done]').forEach((a) => a.addEventListener('click', () => this.remember(365)));

        if (this.inEditor) {
          this.onSelect = (e) => { if (this.contains(e.target) || e.detail.sectionId === this.dataset.sectionId) this.open(true); };
          this.onBlockSelect = (e) => {
            if (!this.contains(e.target)) return;
            this.open(true);
            const id = e.target.dataset.slqOption;
            this.showStep(id && this.querySelector('[data-slq-step="' + id + '"]') ? id : 'question', true);
          };
          this.onDeselect = (e) => { if (e.detail.sectionId === this.dataset.sectionId) this.dialog.close(); };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          if (this.dataset.editorOpen === 'true') this.open(true);
          return;
        }

        if (this.dataset.enabled !== 'true' || this.isSnoozed()) return;

        if (this.dataset.timer === 'true') {
          const delay = Math.max(0, parseInt(this.dataset.delay, 10) || 0) * 1000;
          this.timer = setTimeout(() => this.open(), delay);
        }
        if (this.dataset.exit === 'true') this.setupExitIntent();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.onMouseOut) document.removeEventListener('mouseout', this.onMouseOut);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onSelect) {
          document.removeEventListener('shopify:section:select', this.onSelect);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:section:deselect', this.onDeselect);
        }
      }

      setupExitIntent() {
        const desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (desktop) {
          this.onMouseOut = (e) => {
            if (!e.relatedTarget && e.clientY <= 8) this.open();
          };
          document.addEventListener('mouseout', this.onMouseOut);
        } else {
          let lastY = window.scrollY;
          let lastT = performance.now();
          this.onScroll = () => {
            const y = window.scrollY;
            const t = performance.now();
            const doc = document.documentElement.scrollHeight - window.innerHeight;
            const scrolledEnough = doc > 0 && y / doc > 0.35;
            if (scrolledEnough && lastY - y > 140 && t - lastT < 400) this.open();
            if (t - lastT > 250) { lastY = y; lastT = t; }
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      isSnoozed() {
        try {
          const until = parseInt(localStorage.getItem(this.key) || '0', 10);
          return until > Date.now();
        } catch (e) {
          return false;
        }
      }

      remember(days) {
        if (this.inEditor) return;
        try {
          localStorage.setItem(this.key, String(Date.now() + days * 86400000));
        } catch (e) { /* almacenamiento no disponible */ }
      }

      open(force) {
        if (this.opened && !force) return;
        if (!force && document.querySelector('dialog[open]')) return;
        this.opened = true;
        clearTimeout(this.timer);
        if (this.onMouseOut) document.removeEventListener('mouseout', this.onMouseOut);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        this.lastFocus = document.activeElement;
        this.showStep('question', true);
        if (!this.dialog.open) this.dialog.showModal();
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        this.remember(parseInt(this.dataset.days, 10) || 7);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }

      showStep(id, silent) {
        this.querySelectorAll('[data-slq-step]').forEach((s) => {
          const on = s.dataset.slqStep === id;
          s.hidden = !on;
          s.classList.toggle('is-active', on);
        });
        if (silent) return;
        const active = this.querySelector('[data-slq-step="' + id + '"]');
        if (!active) return;
        const target = id === 'question'
          ? active.querySelector('[data-slq-option]')
          : active.querySelector('[data-slq-result-heading]');
        if (target) target.focus();
      }
    }
    customElements.define('sl-quiz-popup', SlQuizPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
